export default __webpack_public_path__ + "static/media/tourDeFrance.45dd2e7f.jpeg";